/**
 * Gemeinsame Tailwind-Klassen der Teilnehmerseite. Die Seite wird am Handy
 * mit dem Daumen bedient: Knoepfe mindestens 52 px hoch, Text nie unter
 * 16 px (text-base), damit iOS beim Fokus nicht hineinzoomt.
 */
export const KNOPF_BASIS =
  'w-full sm:w-auto px-6 py-3.5 min-h-[52px] text-base font-bold rounded-xl transition-all disabled:opacity-50 disabled:cursor-not-allowed';

export const KNOPF_PRIMAER = `${KNOPF_BASIS} bg-blue-600 hover:bg-blue-700 text-white`;

export const KNOPF_SEKUNDAER = `${KNOPF_BASIS} text-slate-600 border border-slate-200 hover:bg-slate-100 bg-white`;

export const EINGABE =
  'w-full min-h-[48px] px-4 py-3 text-base text-slate-800 bg-white border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500';

export const EINGABE_FEHLER = 'border-red-400 focus:ring-red-400 focus:border-red-400';

export const FEHLERKASTEN = 'p-3 bg-red-50 border border-red-200 rounded-xl text-base text-red-700';

export const HINWEISKASTEN = 'p-3 bg-slate-50 border border-slate-200 rounded-xl text-base text-slate-600';

/** Zusatz, wenn ein Link wie ein Knopf aussehen soll (KNOPF_* sind fuer <button> gebaut). */
export const ALS_LINK = 'inline-flex items-center justify-center text-center no-underline';

/** Fliesstext-Link mit grosser Tippflaeche — auch mitten im Satz gut zu treffen. */
export const TEXTLINK = 'inline-block py-1.5 font-semibold text-blue-700 underline decoration-2 underline-offset-4 hover:text-blue-800';
